import React from 'react';
import { useNavigate } from 'react-router-dom';

const Metric = ({ label, value, wide }) => (
  <div className={`${wide ? 'col-span-2' : ''} border-t border-white/15 pt-3`}>
    <span className="block text-[11px] font-bold uppercase tracking-[0.08em] text-white/45">
      {label}
    </span>
    <span className="mt-1 block text-[17px] font-DMSansFont font-bold text-white">
      {value}
    </span>
  </div>
);

const PlanCard = ({ plan, apiPlan, billingSchedule }) => {
  const navigate = useNavigate();
  const isAnnual = billingSchedule === 'year';
  const isHighlighted = plan.name === 'Grow';
  const price = isAnnual ? plan.annualMonthlyPrice : plan.monthlyPrice;
  const apiPrice = apiPlan?.prices?.find(
    (priceOption) => priceOption.schedule === billingSchedule
  );

  const handleCTA = () => {
    navigate('/signup', { state: { pr_id: apiPrice?.pr_id } });
  };

  return (
    <article
      className={`relative flex h-full flex-col overflow-hidden rounded-[22px] p-7 transition-all duration-300 hover:-translate-y-1 max_600:min-w-[86%] max_600:snap-center max_600:p-6 ${
        isHighlighted
          ? 'bg-ButtonPrimary shadow-[0_22px_60px_rgba(0,160,252,0.3)]'
          : 'bg-white/[0.07] ring-1 ring-inset ring-white/10 hover:bg-white/[0.1]'
      }`}
    >
      <div className="mb-5 flex h-[26px] items-center">
        {plan.badge ? (
          <span className={`rounded-full px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] ${
            isHighlighted ? 'bg-white text-ButtonPrimary' : 'bg-white/10 text-white/80'
          }`}>
            {plan.badge}
          </span>
        ) : (
          <span className="text-[11px] font-bold uppercase tracking-[0.12em] text-white/45">
            For smaller teams
          </span>
        )}
      </div>

      <h3 className="text-[30px] font-DMSansFont font-bold tracking-[-0.5px] text-white">
        {plan.name}
      </h3>
      <p className={`mt-1 text-[15px] font-bold ${isHighlighted ? 'text-white' : 'text-[#75C9FF]'}`}>
        {plan.outcome}
      </p>
      <p className="mt-3 min-h-[48px] text-[13px] leading-5 text-white/65 max_600:min-h-0">
        {plan.idealFor}
      </p>

      <div className="mt-6 flex items-end gap-2">
        <span className="text-[42px] font-DMSansFont font-bold leading-none tracking-[-1.5px] text-white">
          ${price.toLocaleString()}
        </span>
        <span className="pb-1 text-[13px] font-semibold text-white/55">/month</span>
      </div>
      <p className="mt-2 text-[11px] font-semibold uppercase tracking-[0.08em] text-white/40">
        {isAnnual ? 'Billed annually' : 'Billed monthly'}
      </p>

      <div className="mt-6 grid grid-cols-2 gap-x-5 gap-y-4">
        <Metric label="Users" value={plan.users} />
        <Metric label="Active records" value={plan.records} />
        <Metric label="Concurrency" value={plan.concurrency} />
        <Metric label="Campaigns" value={plan.campaigns} />
        <Metric label="Workflows" value={plan.workflows} wide />
      </div>

      <ul className="mt-6 space-y-2.5 text-[13px] leading-5 text-white/70 max_600:hidden">
        {plan.features.map((feature) => (
          <li key={feature} className="flex gap-2.5">
            <span aria-hidden="true" className="font-bold text-white">✓</span>
            <span>{feature}</span>
          </li>
        ))}
      </ul>

      <div className="mt-auto pt-6">
        <button
          type="button"
          onClick={handleCTA}
          className={`w-full rounded-[10px] px-4 py-3 text-[14px] font-bold transition-colors ${
            isHighlighted
              ? 'bg-white text-LightPrimary hover:bg-white/90'
              : 'bg-white text-LightPrimary hover:bg-[#EAF7FF]'
          }`}
        >
          {plan.cta}
        </button>
      </div>
    </article>
  );
};

export default PlanCard;
